<template>
    <div class="d-flex flex-column justify-content-center align-items-center p-5">
        <div class="my-4" style="width: 100%;">
            <FormContainer heading="Edit Location">
                <template v-slot:content>
                    <form>
                        <div class="row">
                            <!-- ID -->
                            <div class="col-md-6 mb-3">
                                <material-input id="id" type="text" label="ID" name="id" v-model="location.id"
                                    :read-only="true" disabled />
                            </div>
                            <!-- Name -->
                            <div class="col-md-6 mb-3">
                                <material-input id="name" type="text" label="Name" name="name"
                                    v-model="location.name" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Description -->
                            <div class="col-12 mb-3">
                                <material-input id="description" type="text" label="Description" name="description"
                                    v-model="location.description" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Email -->
                            <div class="col-md-6 mb-3">
                                <material-input id="email" type="email" label="Email" name="email"
                                    v-model="location.email" disabled />
                            </div>
                            <!-- Phone -->
                            <div class="col-md-6 mb-3">
                                <material-input id="phone" type="tel" label="Phone Number" name="phone"
                                    v-model="location.phone" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Priority -->
                            <div class="col-md-6 mb-3">
                                <material-input id="priority" type="number" label="Priority" name="priority"
                                    v-model="location.priority" disabled />
                            </div>
                            <!-- Status -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="status" label="Status" name="status"
                                    v-model="location.status" :options="statusOptions" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Display Ads -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="displayAds" label="Display Bible based content" name="displayAds"
                                    :checked="location.displayAds" disabled />
                            </div>
                            <!-- Display Inspirational Messages -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="displayMessages" label="Display Inspirational Messages"
                                    name="displayMessages" :checked="location.displayMessages" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- User self register -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="userRegister" label="User Self Register" name="userRegister"
                                    :checked="location.userRegister" disabled />
                            </div>
                            <!-- Users can view schedules -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="viewSchedules" label="Users can view All Schedules"
                                    name="viewSchedules" :checked="location.viewSchedules" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Non-admin users can choose activities -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="userpreferredoptions"
                                    label="Non-admin users can choose Activities/Workgroups" name="userpreferredoptions"
                                    :checked="location.userpreferredoptions" disabled />
                            </div>
                            <!-- Enable reminders -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="enableReminders" label="Enable Reminders (SMS, Email)"
                                    name="enableReminders" :checked="location.enableReminders" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Enable AI chat -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="enableAiChat" label="Enable AI chat feature"
                                    name="enableAiChat" :checked="location.enableAiChat" disabled />
                            </div>
                            <!-- Enable AI schedule generation -->
                            <div class="col-md-6 mb-3">
                                <MaterialSwitch id="enableAiScheduleGeneration" label="Enable AI schedule generation feature"
                                    name="enableAiScheduleGeneration" :checked="location.enableAiScheduleGeneration" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Auto-Scheduler completion notification -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="autoScheduler" label="Auto-Scheduler Notification"
                                    name="autoScheduler" v-model="location.autoScheduler" :options="yesNoOptions" disabled />
                            </div>
                            <!-- TimeZone -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="timezone" label="Time Zone" name="timezone"
                                    v-model="location.timezone" :options="timezonesOptions" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Country -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="country" label="Country" name="country" :options="countriesOptions"
                                    v-model="location.country" disabled />
                            </div>
                            <!-- Default Skill -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="defaultSkill" type="text" label="Default Skill" name="defaultSkill"
                                    :options="allSkills" v-model="location.defaultSkill" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Default View Mode -->
                            <div class="col-md-6 mb-3">
                                <MaterialSelect id="viewMode" label="Default View Mode" name="viewMode"
                                    :options="viewModeOptions" v-model="location.viewMode" disabled />
                            </div>
                            <!-- Send SMS/Text -->
                            <div class="col-md-6 mb-3">
                                <material-input id="sendSmsDays" type="number" label="Send SMS/Text (days before)"
                                    name="sendSmsDays" v-model="location.sendSmsDays" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Do not send Volunteer E-mail reminders on -->
                            <div class="col-12 mb-3">
                                <label class="form-label">Do not send Volunteer E-mail reminders on</label>
                                <div class="d-flex gap-5 flex-wrap">
                                    <MaterialSwitch v-for="day in weekDays" :key="day.value" :id="day.value"
                                        :name="day.value" :label="day.label"
                                        :checked="location.noEmailDays.includes(day.value)" disabled />
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <!-- URLs -->
                            <div class="col-md-4 mb-3">
                                <material-input id="websiteUrl" type="text" label="Location Website URL"
                                    name="websiteUrl" v-model="location.websiteUrl" disabled />
                            </div>
                            <div class="col-md-4 mb-3">
                                <material-input id="customUrl" type="text" label="Custom URL" name="customUrl"
                                    v-model="location.customUrl" disabled />
                            </div>
                            <div class="col-md-4 mb-3">
                                <material-input id="loginUrl" type="text" label="Custom Login URL" name="loginUrl"
                                    v-model="location.loginUrl" disabled />
                            </div>
                        </div>

                        <div class="row">
                            <!-- Last Admin Report Date -->
                            <div class="col-12 mb-3">
                                <material-input id="lastReportDate" type="text" label="Last Admin Report Date"
                                    name="lastReportDate" v-model="location.lastReportDate" :read-only="true" disabled />
                            </div>
                        </div>
                    </form>
                </template>
            </FormContainer>
        </div>

        <div class="my-4" style="width: 100%;">
            <FormContainer heading="Select Admins for this location">
                <template v-slot:content>
                    <TagSelector mainHeading="" optionName="users" availableOptionsHeading="All Users"
                        selectedOptionsHeading="Current Admins" :initial-skills="allUsers"
                        v-model:interests="currentAdmins" :loading="loading" :show-default-message="false" 
                        :disabled="true" />
                </template>
            </FormContainer>
        </div>
    </div>
</template>

<script setup>
import { computed, onMounted, reactive, ref } from 'vue'
import { useStore } from 'vuex'
import MaterialInput from '@/components/common/MaterialInput.vue'
import MaterialSelect from '@/components/common/MaterialSelect.vue'
import TagSelector from '@/components/common/TagSelector.vue'
import MaterialSwitch from '@/components/common/MaterialSwitch.vue'
import FormContainer from '../../components/PageLayout/FormContainer.vue'

const props = defineProps({
    locationId: {
        type: [String, Number],
        required: true
    }
})

const store = useStore()
const loading = ref(false);

const location = reactive({
    id: null,
    name: "",
    description: "",
    email: "",
    phone: "",
    priority: 0,
    status: "inactive",
    displayAds: false,
    displayMessages: false,
    userRegister: false,
    viewSchedules: false,
    userpreferredoptions: false,
    enableReminders: false,
    enableAiChat: false,
    enableAiScheduleGeneration: false,
    autoScheduler: "no",
    timezone: "America/Chicago",
    country: "",
    defaultSkill: "",
    viewMode: "grid",
    sendSmsDays: 0,
    noEmailDays: [],
    websiteUrl: "",
    customUrl: "",
    loginUrl: "",
    lastReportDate: ""
})

const statusOptions = [
    { value: "active", label: "Active" },
    { value: "inactive", label: "Inactive" }
]

const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" }
]

const viewModeOptions = ref([])

const weekDays = [
    { value: "Mon", label: "Mon" },
    { value: "Tue", label: "Tue" },
    { value: "Wed", label: "Wed" },
    { value: "Thu", label: "Thu" },
    { value: "Fri", label: "Fri" },
    { value: "Sat", label: "Sat" },
    { value: "Sun", label: "Sun" }
]

const allSkills = ref([])
const allUsers = ref([])
const currentAdmins = ref([])

const countriesOptions = computed(() => {
    const countries = store.getters["stCountries"] || {}
    return Object.keys(countries).map(key => ({
        label: countries[key],
        value: key
    }))
})

const timezonesOptions = computed(() => {
    const zones = store.getters["stTimezones"] || {}
    return Object.keys(zones).map(key => ({
        label: zones[key],
        value: key
    }))
})

onMounted(async () => {
    loading.value = true;
    try {       
        const response = await store.dispatch("getLocationManagementInfo", String(props.locationId))

        store.dispatch("getCountries")
        store.dispatch("getTimezones")

        var locationDetails = response.location_details.data

        allSkills.value = (locationDetails.skills || []).map(skill => ({
            value: skill.skillid,
            label: skill.skillname,
        }))

        viewModeOptions.value = (locationDetails.view_modes || []).map(mode => ({
            value: mode.value,
            label: mode.label
        }))

        allUsers.value = response.admins.all_users.map(user => ({
            id: user.personid,
            name: user.display_text,
            description: user.email
        }));

        currentAdmins.value = response.admins.current_admins.map(user => ({
            id: user.personid,
            name: user.display_text,
            description: user.email
        }));

        location.id = locationDetails.id
        location.name = locationDetails.name
        location.description = locationDetails.description
        location.email = locationDetails.email
        location.phone = locationDetails.phone
        location.priority = locationDetails.priority
        location.status = locationDetails.status
        location.displayAds = !!locationDetails.showads
        location.displayMessages = !!locationDetails.showinspirations
        location.userRegister = !!locationDetails.selfregister
        location.viewSchedules = !!locationDetails.userscheduleview
        location.userpreferredoptions = (locationDetails.userpreferredoptions === "1" || locationDetails.userpreferredoptions === 1)
        location.enableReminders = !!locationDetails.reminders_enabled
        location.enableAiChat = !!(locationDetails.enable_ai_chat ?? false)
        location.enableAiScheduleGeneration = !!(locationDetails.enable_ai_schedulegeneration ?? false)
        location.autoScheduler = locationDetails.autoschedule_complete_adminalert ? "yes" : "no"
        location.timezone = locationDetails.timezone
        location.country = locationDetails.country
        location.defaultSkill = locationDetails.default_skill ?? ""
        location.viewMode = locationDetails.default_view_mode ?? 0
        location.sendSmsDays = locationDetails.smsdays ?? 0
        location.noEmailDays = locationDetails.exclude_email_days ?? []
        location.websiteUrl = locationDetails.location_url ?? ""
        location.customUrl = locationDetails.custom_url ?? ""
        location.loginUrl = locationDetails.custom_login_url ?? ""
        location.lastReportDate = locationDetails.last_admin_alert_dt ?? ""
    }
    finally {
        loading.value = false;
    }
})
</script>

